import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import img3 from "../Media/img-projects-5.jpeg";
import img5 from "../Media/google_cloud_service.jpg";
import img6 from "../Media/service6_data_banner.jpg";
import img8 from "../Media/dynamics_service.png";
import img9 from "../Media/data_service.png";
import img12 from "../Media/ki_service.jpg";
import img13 from "../Media/prozessdigitalisierung_service.jpg";


import "./ServiceGrid.css";

import ProgressiveImageCustom from "../Components/ProgressiveImageCustom.tsx";

function ServiceGrid() {
  const [filter, setFilter] = useState("All");
  const gridRef = useRef(null);
  const navigate = useNavigate();

  const services = [
    {
      title: "Micro­soft Dy­namics 365",
      description:
        "Op­ti­mie­ren Sie Ihre Ge­schäfts­pro­zesse mit Micro­soft CRM und ERP-Sys­te­men. Wir sind Ihr Part­ner bei der Um­set­zung von Kom­plett­lö­sun­gen vom Da­ten­mo­dell über mass­ge­schnei­derte Er­wei­te­run­gen und In­te­gra­tio­nen in die be­ste­hende Sys­tem­land­schaft.",
      img: img8,
      category: "Microsoft Dynamics 365",
      key: "Microsoft Dynamics 365",
    },
    {
      title: "Künst­liche In­telli­genz",
      description:
        "Mass­geschneiderte KI-Lösungen in Berei­chen wie Kommuni­kation, Datenv­erarbeitung und Entscheidungs­findung ermögli­chen eine signifi­kante Steigerung der Effi­zienz, eine Verein­fachung komplexer Abläufe und eine nach­haltige Opti­mierung von Arbeits­prozessen.",
      img: img12,
      category: "Künstliche Intelligenz",
      key: "Künstliche Intelligenz",
    },
    ,
    {
      title: "Pro­zess­di­gi­ta­li­sie­rung",
      description:
        "Trans­for­mie­ren Sie Ihre ana­logen Ar­beits­ab­läufe in ef­fi­ziente, di­gi­tale Pro­zesse. Mit mass­ge­schnei­der­ten Lö­sun­gen er­mög­li­chen wir pa­pier­lose Ab­läufe, op­ti­mierte Work­flows und eine reibungs­lose Zu­sam­men­ar­beit zwi­schen Teams und Ab­tei­lun­gen.",
      img: img13,
      category: "Prozessdigitalisierung",
      key: "Prozessdigitalisierung",
    },

    {
      title: "Google Cloud",
      description:
        "Ob Google Cloud De­ploy­ments, Cloud Func­tions, Chrome Ex­ten­sions oder Apps Script, wir sind Ihr Part­ner im Google-Öko­sys­tem. Von der Auto­ma­ti­sie­rung wie­der­keh­ren­der Auf­gaben bis zur Ent­wick­lung mass­ge­schnei­der­ter An­wen­dun­gen bie­ten wir um­fas­sende Ex­per­tise für Ihre An­for­de­run­gen.",
      img: img5,
      category: "Google Cloud",
      key: "Google Cloud",
    },
    {
      title: "Web­sites und Web­apps",
      description:
        "Wir ent­wickeln Ihre Web­site, Web-Apps oder Web­shop. Von der Ge­stal­tung des Front­ends bis zur Um­set­zung er­wei­ter­ter Funk­tio­nen, etwa Be­nutzer­an­mel­dun­gen oder die In­te­gra­tion von Sys­te­men.",
      img: img3,
      category: "Websites und Webapps",
      key: "Websites und Webapps",
    },
    {
      title: "Da­ten­ana­lyse",
      description:
        "Nutzen Sie das Po­ten­zial Ihrer Da­ten, um fun­dierte Ent­schei­dungen zu tref­fen. Wir bie­ten in­di­vi­duelle Data-Science-Lö­sun­gen, von Da­ten­ana­lyse und Vi­sua­li­sie­rung bis hin zur Ent­wick­lung mass­ge­schnei­der­ter Ma­chine-Learning-Mo­delle.",
      img: img6,
      category: "Datenanalyse",
      key: "Datenanalyse",
    },
    {
      title: "Da­ten­banken & Da­ten­mo­delle",
      description:
        "Ba­sis für da­ten­ge­triebene Ent­schei­dungen sind eine qua­li­ta­tive Da­ten­basis und gute Da­ten­mo­delle. Wir ent­wickeln ska­lier­bare Lö­sun­gen, die Ihre Da­ten­struk­turen klar und zu­gäng­lich ge­stal­ten.",
      img: img9,
      category: "Datenbanken & Datenmodelle",
      key: "Datenbanken & Datenmodelle",
    },
  ];
  

  useEffect(() => {
    const gridElement = gridRef.current;

    if (!gridElement) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            entry.target.classList.remove("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    const items = gridElement.querySelectorAll(".service-item");
    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, [filter]); // Depend on filter to refresh visibility classes on updates

  const handleLearnMore = (featureName) => {
    navigate(`/${featureName}`, { state: { preselectedTopic: featureName } });
  };

  const handleInquiry = (featureName) => {
    navigate("/inquiry", { state: { preselectedTopic: featureName } });
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  const filteredServices =
    filter === "All"
      ? services
      : services.filter((service) => service.category === filter);

  return (
    <div>
      <div className="filter-container">
        <label htmlFor="filter">Filter:</label>
        <select className="filter" id="filter" value={filter} onChange={handleFilterChange}>
          <option value="All">Alle</option>
          <option value="Microsoft Dynamics 365">CRM/ERP</option>
          <option value="Websites und Webapps">Web Development</option>
          <option value="Google Cloud">Google Cloud</option>
          <option value="Prozessdigitalisierung">Prozessdigitalisierung</option>
          <option value="Künstliche Intelligenz">Künstliche Intelligenz</option>
          <option value="Datenanalyse">Datenanalyse</option>
          <option value="Datenbanken & Datenmodelle">Datenbanken & Datenmodelle</option>
        </select>
      </div>

      <div className="service-grid" ref={gridRef}>
        {filteredServices.map((service) => (
          <div className="service-item" key={service.key}>
            <p className="service-item-title">
              <b>{service.title}</b>
            </p>
            <ProgressiveImageCustom src={service.img} />
            <p className="service-item-description">{service.description}</p>
            <div className="button-group">
              <button
                className="anfrage-btn"
                onClick={() => handleInquiry(service.key)}
              >
                Anfrage
              </button>
              <button
                className="learn-more-btn"
                onClick={() => handleLearnMore(service.key)}
              >Mehr
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ServiceGrid
